import { useSelector } from 'react-redux';
import { selectors as appSelectors } from 'store/features/application';

import useStyles from './useStyles';
import Snack from './components/Snack';

const Notice = () => {
  const data = useSelector(appSelectors.notice);
  const classes = useStyles();

  if (!data?.length) return <></>;
  return (
    <div className={classes.stack}>
      {data?.map((props) => <Snack key={props.id} {...props} />)}
    </div>
  );
};

export default Notice;
